import { SearchInput } from '../../../../../../../components';
import { ASSIGNED_USERS_PAGE_SIZE } from '../../constants';
import { useAssignedUsersList } from '../../hooks';
import { PermittedUser } from '../../types';
import { UsersPagination } from '../UsersPagination';
import { AssignedUserRow } from './AssignedUserRow';
import styles from './AssignedUsersCard.module.scss';

type AssignedUsersCardProps = {
  users: PermittedUser[];
  busy: boolean;
  onAdd: () => void;
  onRemove: (user: PermittedUser) => void;
};

export const AssignedUsersCard = ({ users, busy, onAdd, onRemove }: AssignedUsersCardProps) => {
  const { search, page, total, pageUsers, onSearch, onChangePage } = useAssignedUsersList(users);

  const addButton = (
    <button type="button" className={styles.addButton} disabled={busy} onClick={onAdd}>
      Adicionar usuários
    </button>
  );

  if (users.length === 0) {
    return (
      <div className={`${styles.card} ${styles.empty}`}>
        <p>Nenhum usuário selecionado. Enquanto a lista estiver vazia, só administradores podem aplicar preços no Gerenciador.</p>
        {addButton}
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div className={styles.toolbar}>
        <SearchInput
          aria-label="Buscar por usuário"
          className={styles.search}
          placeholder="Buscar por usuário"
          value={search}
          onChange={event => onSearch(event.target.value)}
        />
        {addButton}
      </div>

      <div className={styles.list} aria-live="polite">
        {pageUsers.length > 0 ? (
          pageUsers.map(user => (
            <AssignedUserRow key={user.cd_usuario} user={user} disabled={busy} onRemove={onRemove} />
          ))
        ) : (
          <div className={styles.feedback}>
            <p>Nenhum usuário encontrado para “{search}”.</p>
            <button type="button" onClick={() => onSearch('')}>
              Limpar busca
            </button>
          </div>
        )}
      </div>

      <UsersPagination total={total} pageSize={ASSIGNED_USERS_PAGE_SIZE} page={page} onChangePage={onChangePage} />
    </div>
  );
};
